// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__OOrBh","loader":"loader_loader__d+2nk","Table":"loader_Table__5M15A"};